import { Component } from 'san';
import * as _ from 'lodash';

import { IUser, IShowTurnParams, ITurnCommand, ITurnCallback, IHandlerPerson } from 'src/models';

import auditService from 'src/services/audit.service';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import toasterService from 'src/services/toaster.service';
import { EAuditStatus } from 'src/enums';

export default class Turn extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        auditId: string; // 审批id
        isShow: boolean; // 显示
        isBusy: boolean;
        checkedUser: IUser; // 选中的用户（被转办人）
        disabledUsers?: IUser[]; // 禁止转办的用户（工作流当前节点上的审批人）
        remark?: string;
        callback?: ITurnCallback;
        cancelCallback?: ITurnCallback;
        userId?: string; // 转办人（管理员转办时须传单子的当前处理人）
        auditUsers: IHandlerPerson[]; // 流程审批人员列表，管理员转办时使用
        title: string;
    } {
        return {
            auditId: null,
            isShow: false,
            isBusy: false,
            checkedUser: null,
            disabledUsers: [],
            remark: '',
            callback: null,
            cancelCallback: null,
            userId: null,
            auditUsers: [],
            title: '转办',
        };
    }

    inited() {}

    // 显示转办（外部调用）
    show(params: IShowTurnParams) {
        this.data.set('isShow', true);
        this.data.set('isBusy', false);
        this.data.set('auditId', params.auditId);
        this.data.set('callback', params.callback);
        this.data.set('cancelCallback', params.cancelCallback);
        this.data.set('userId', params.userId);
        this.data.set('auditUsers', []);
        this.getDisabledUsers(params.auditId);
        this.data.set('title', params.title ?? '转办');
    }

    // 获取禁止转办的用户列表（工作流当前节点的审批人）
    getDisabledUsers(auditId: string) {
        auditService
            .getAuditWorkflowCurrentStepPersonsAndAuditStatus(auditId, true)
            .then((result) => {
                const currentStepPersons = result.handlePersons;
                const status = result.auditStatus;
                const dataKey = 'disabledUsers';
                const disabledUsers = this.data.get('disabledUsers');
                this.data.splice(dataKey, [0, disabledUsers.length, ...currentStepPersons]);

                const userId = this.data.get('userId');
                const auditUsers = currentStepPersons.filter((u) => u.status == 0);
                const auditUserIds = auditUsers.map((u) => u.user_id);

                // 使用 userId 来标记是否管理员转办，同时校验当前 userId 有效性，否则予以覆盖
                if (userId && auditUsers.length > 0 && status === EAuditStatus.Reviewing) {
                    this.data.set('auditUsers', auditUsers);
                    if (auditUserIds.includes(userId) == false) {
                        this.data.set('userId', auditUserIds[0]);
                    }
                }
            });
    }

    toCheckUser() {
        checkOrgUsersService.show({
            disabledUsers: this.data.get('disabledUsers'),
            callback: (users) => {
                this.checkUser(users);
            },
        }, true);
    }

    toCheckAuditTurn(user: IHandlerPerson) {		
        this.data.set('userId', user.user_id);		
    }

    checkUser(users: IUser[]) {
        if (!users.length) {
            return;
        }
        const dataKey = 'checkedUser';
        this.data.set(dataKey, users[0]);
    }

    submit() {
        const data = this.data.get();
        if (data.isBusy) {
            return;
        }
        if (-1 !== _.findIndex(data.disabledUsers, { user_id: data.checkedUser.user_id })) {
            toasterService.show({
                type: 'danger',
                title: '转办接收人已是当前节点审批人，无需转办',
            });
            return;
        }
        const turnCommand: ITurnCommand = {
            id: data.auditId,
            account: data.checkedUser.user_id,
            remark: data.remark,
            user_id: data.userId,
        };
        this.data.set('isBusy', true);
        auditService.turnAudit(turnCommand).then(
            () => {
                if (data.callback) {
                    data.callback();
                }
                this.data.set('isShow', false);
                this.data.set('isBusy', false);
            },
            () => {
                this.data.set('isBusy', false);
            }
        );
    }

    cancel() {
        const data = this.data.get();
        if (data.isBusy) {
            return;
        }
        const cancelCallback = data.cancelCallback;
        if (cancelCallback) {
            cancelCallback();
        }
        this.data.set('isBusy', false);
        this.data.set('isShow', false);
        this.data.set('auditUsers', []);
        this.data.set('checkedUser', null);
        this.data.set('remark', '');
    }
}
